import { render, staticRenderFns } from "./imagenesComponent.vue?vue&type=template&id=3b9b6ccf&scoped=true"
import script from "./imagenesComponent.vue?vue&type=script&lang=js"
export * from "./imagenesComponent.vue?vue&type=script&lang=js"
import style0 from "./imagenesComponent.vue?vue&type=style&index=0&id=3b9b6ccf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9b6ccf",
  null
  
)

export default component.exports